@if (is_create()) {
  <p class="attachments-empty-hint">Guarda el acta para poder subir y gestionar archivos.</p>
} @else if (attachments().length === 0) {
  <p class="attachments-empty-hint">No hay archivos adjuntos. Arrastra un fichero a esta pantalla o usa el menú ⋮ para subir.</p>
} @else {
  <ul class="attachments-list">
    @for (row of attachment_rows(); track row.attachment.id) {
      <li class="attachment-row">
        <div class="attachment-meta">
          @if (row.is_image) {
            <img class="attachment-thumb" [src]="row.attachment.file_path" [alt]="row.attachment.file_name" />
          } @else {
            <mat-icon class="attachment-icon" aria-hidden="true">attach_file</mat-icon>
          }
          <div class="attachment-text">
            <span class="attachment-name">{{ row.attachment.file_name }}</span>
            <span class="attachment-date">{{ row.attachment.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>
        <div class="attachment-actions">
          <button mat-icon-button type="button" (click)="download_attachment.emit(row.attachment)" aria-label="Descargar archivo">
            <mat-icon>download</mat-icon>
          </button>
          @if (can_manage()) {
            <button
              mat-icon-button
              type="button"
              color="warn"
              (click)="delete_attachment.emit(row.attachment)"
              aria-label="Eliminar archivo"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </li>
    }
  </ul>
}
